import { CIcon } from '~/icons/types'
export const ciCashier: CIcon = {
  name: 'cashier',
  type: 'light',
  width: 512,
  height: 512,
  paths: [
    {
      d:
        'M511.991 406.961c0-1.191-.192-2.387-.602-3.539-8.839-24.839-43.436-110.619-51.908-134.28V151.709c0-13.509-10.991-24.5-24.5-24.5h-51.289v-26.392h43.26c12.527 0 22.719-10.191 22.719-22.719V28.525c0-12.528-10.191-22.719-22.719-22.719H271.813c-12.528 0-22.719 10.191-22.719 22.719v49.572c0 12.528 10.191 22.719 22.719 22.719h43.26v26.392h-94.087V91.843c0-4.266-2.567-8.113-6.507-9.749l-30.493-12.668a10.548 10.548 0 0 0-8.1 0l-26.45 10.986-26.449-10.986a10.556 10.556 0 0 0-14.607 9.748v48.033H77.02c-13.509 0-24.5 10.991-24.5 24.5V269.14C44.047 292.802 9.45 378.582.611 403.421l.006.009A10.537 10.537 0 0 0 0 406.961v88.676c0 5.83 4.727 10.557 10.557 10.557h490.887c5.829 0 10.557-4.726 10.557-10.557v-88.676h-.01zM271.813 79.703c-.885 0-1.606-.72-1.606-1.606V28.525c0-.886.721-1.606 1.606-1.606h155.139c.886 0 1.606.72 1.606 1.606v49.572c0 .886-.72 1.606-1.606 1.606H271.813zm90.765 21.114v26.392h-26.392v-26.392h26.392zm-209.091.775 26.45-10.985 19.937 8.283v94.826h-70.377V94.992l15.891 6.601a10.555 10.555 0 0 0 8.099-.001zm-79.854 50.116a3.391 3.391 0 0 1 3.387-3.387h31.363v55.951c0 5.831 4.727 10.557 10.557 10.557h91.491c5.829 0 10.557-4.726 10.557-10.557v-55.951H434.98a3.391 3.391 0 0 1 3.387 3.387v108.514H73.633V151.708zm-3.06 129.628h370.856c8.015 22.037 37.911 96.146 44.941 115.068H25.631c7.029-18.922 36.927-93.031 44.942-115.068zM490.887 485.08H21.113v-67.563h469.773v67.563z'
    },
    {
      d:
        'm449.852 360.832-2.341-5.885c-2.157-5.418-8.298-8.061-13.711-5.906-5.418 2.156-8.062 8.293-5.908 13.711l2.341 5.885a10.561 10.561 0 0 0 9.812 6.657c1.298 0 2.619-.242 3.899-.751 5.418-2.155 8.062-8.293 5.908-13.711z'
    },
    {
      d:
        'm431.614 314.99-2.341-5.885c-2.156-5.418-8.294-8.061-13.711-5.908-5.418 2.156-8.062 8.293-5.908 13.711l2.341 5.885a10.562 10.562 0 0 0 9.813 6.657c1.298 0 2.618-.242 3.899-.75 5.417-2.154 8.062-8.293 5.907-13.71z'
    },
    {
      d:
        'M402.391 355.829c-1.668-5.588-7.55-8.762-13.135-7.096-5.587 1.668-8.764 7.548-7.096 13.135l1.757 5.885c1.367 4.579 5.564 7.54 10.111 7.54 1 0 2.016-.144 3.023-.443 5.587-1.668 8.764-7.548 7.096-13.135l-1.756-5.886z'
    },
    {
      d:
        'm390.469 315.872-1.757-5.885c-1.668-5.587-7.549-8.766-13.135-7.096-5.587 1.667-8.764 7.548-7.096 13.135l1.757 5.885c1.367 4.579 5.564 7.541 10.111 7.541 1 0 2.016-.143 3.023-.443 5.588-1.669 8.765-7.55 7.097-13.137z'
    },
    {
      d:
        'M357.204 356.79c-1.136-5.719-6.697-9.431-12.413-8.295-5.719 1.137-9.432 6.694-8.294 12.413l1.17 5.885c.998 5.023 5.408 8.5 10.342 8.5.682 0 1.376-.066 2.07-.205 5.719-1.137 9.432-6.694 8.294-12.413l-1.169-5.885z'
    },
    {
      d:
        'M340.96 329.246c5.719-1.137 9.432-6.694 8.294-12.413l-1.17-5.885c-1.136-5.72-6.691-9.433-12.413-8.295-5.719 1.137-9.432 6.694-8.294 12.413l1.17 5.885c.998 5.024 5.408 8.5 10.342 8.5a10.691 10.691 0 0 0 2.071-.205z'
    },
    {
      d:
        'M311.929 357.804c-.577-5.801-5.743-10.039-11.55-9.459-5.801.577-10.037 5.748-9.46 11.55l.586 5.885c.543 5.446 5.132 9.513 10.492 9.513.349 0 .702-.018 1.058-.053 5.801-.577 10.037-5.748 9.46-11.55l-.586-5.886z'
    },
    {
      d:
        'M298.497 329.397c5.801-.576 10.037-5.748 9.46-11.55l-.586-5.885a10.545 10.545 0 0 0-11.55-9.459c-5.801.576-10.037 5.748-9.46 11.55l.586 5.885c.543 5.446 5.132 9.513 10.492 9.513.35-.002.702-.019 1.058-.054z'
    },
    {
      d:
        'M256 348.292c-5.829 0-10.557 4.726-10.557 10.557v5.885c0 5.831 4.727 10.557 10.557 10.557s10.557-4.726 10.557-10.557v-5.885c0-5.831-4.728-10.557-10.557-10.557z'
    },
    {
      d:
        'M256 302.45c-5.829 0-10.557 4.726-10.557 10.557v5.885c0 5.83 4.727 10.557 10.557 10.557s10.557-4.726 10.557-10.557v-5.885c0-5.831-4.728-10.557-10.557-10.557z'
    },
    {
      d:
        'M211.621 348.345c-5.813-.585-10.974 3.658-11.55 9.459l-.586 5.885c-.577 5.802 3.659 10.973 9.46 11.55.356.036.708.053 1.058.053 5.36 0 9.951-4.066 10.492-9.513l.586-5.885c.577-5.801-3.659-10.973-9.46-11.549z'
    },
    {
      d:
        'M216.179 302.501c-5.807-.585-10.974 3.658-11.55 9.459l-.586 5.885c-.577 5.802 3.659 10.974 9.46 11.55.356.036.708.053 1.058.053 5.36 0 9.951-4.066 10.492-9.513l.586-5.885c.577-5.801-3.659-10.971-9.46-11.549z'
    },
    {
      d:
        'M167.209 348.495c-5.723-1.137-11.277 2.577-12.413 8.295l-1.17 5.885c-1.137 5.719 2.576 11.276 8.294 12.413.696.138 1.387.205 2.07.205 4.933 0 9.345-3.476 10.342-8.5l1.17-5.885c1.138-5.719-2.575-11.276-8.293-12.413z'
    },
    {
      d:
        'M176.326 302.652c-5.718-1.138-11.277 2.577-12.413 8.295l-1.17 5.885c-1.137 5.719 2.576 11.276 8.294 12.413.695.138 1.387.205 2.07.205 4.934 0 9.345-3.476 10.342-8.5l1.17-5.885c1.14-5.719-2.574-11.276-8.293-12.413z'
    },
    {
      d:
        'M122.744 348.733c-5.587-1.67-11.468 1.51-13.135 7.096l-1.757 5.885c-1.668 5.587 1.51 11.468 7.096 13.135 1.007.301 2.024.443 3.023.443 4.547 0 8.744-2.96 10.111-7.54l1.757-5.885c1.669-5.585-1.509-11.466-7.095-13.134z'
    },
    {
      d:
        'M136.423 302.891c-5.588-1.67-11.467 1.51-13.135 7.096l-1.757 5.885c-1.668 5.587 1.51 11.468 7.096 13.135 1.007.301 2.024.443 3.023.443 4.547 0 8.744-2.96 10.111-7.541l1.757-5.885c1.668-5.585-1.508-11.466-7.095-13.133z'
    },
    {
      d:
        'M78.201 349.04c-5.416-2.156-11.555.489-13.711 5.906l-2.341 5.885c-2.155 5.417.49 11.555 5.908 13.711 1.281.51 2.6.751 3.899.751a10.56 10.56 0 0 0 9.812-6.657l2.341-5.885c2.154-5.417-.49-11.556-5.908-13.711z'
    },
    {
      d:
        'M96.44 303.197c-5.418-2.155-11.554.49-13.711 5.908l-2.341 5.885c-2.155 5.418.49 11.556 5.908 13.711 1.281.509 2.6.75 3.899.75a10.56 10.56 0 0 0 9.812-6.657l2.341-5.885c2.153-5.419-.492-11.556-5.908-13.712z'
    },
    {
      d:
        'M406.697 169.435H292.069c-5.829 0-10.557 4.726-10.557 10.557v48.561c0 5.83 4.727 10.557 10.557 10.557h114.628c5.829 0 10.557-4.726 10.557-10.557v-48.561c0-5.831-4.728-10.557-10.557-10.557zm-10.557 48.561h-93.514v-27.447h93.514v27.447z'
    },
    {
      d:
        'M154.656 152.28h20.058c5.829 0 10.557-4.726 10.557-10.557 0-5.83-4.727-10.557-10.557-10.557h-20.058c-5.829 0-10.557 4.726-10.557 10.557s4.727 10.557 10.557 10.557z'
    }
  ]
}
